"use strict";

angular.module("vendor")
.service("SupportVendorService", function($resource, appConfig) {
    var queryResource = $resource(appConfig.API_SERVER + "/auth/impersonate/vendors/", {}, {
        query: {
            method: "get",
            isArray: false
        }
    });
    var impersonateResource = $resource(appConfig.API_SERVER + "/auth/impersonate/vendors/:id/start/", {id: "@id"}, {
        update: {
            method: "PUT"
        }
    });

    this.query = function(params) {
        return queryResource.query(params);
    };

    this.impersonate = function(vendor_id) {
        return impersonateResource.update({id: vendor_id});
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/support/support-vendor.service.js
// module id = 883
// module chunks = 0